'use client';

import React from 'react';
import NewsAndEventsListSection from '@/components/organisms/news-and-events-list';

const NewsAndEventsListTastic = ({ data }: any) => {
    let news = Array.isArray(data?.data?.dataSource) ? data.data.dataSource : [];
    const filteredNews = news.filter((newsF:any)=>{
        return newsF.tags.includes("plumbers")
    })
    return <NewsAndEventsListSection news={filteredNews} />
};

export default NewsAndEventsListTastic;
